<template>
    <main
        id="app"
        v-loading.fullscreen.lock="!visible"
        element-loading-text="加载中..."
    >
        <router-view v-if="visible" />
    </main>
</template>

<script>
import Cookies from 'js-cookie'
import { mapMutations } from 'vuex'
import * as T from '@store/types'
import resetCookies from '@utils/resetCookies'
import devComponentMixin from '@common/mixins/devComponent'
import init from '../../mixins/init'

export default {
    name: 'Main',

    mixins: [init, devComponentMixin],

    data() {
        return {
            cookies: {},
            visible: false,
        }
    },
    async created() {
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                resetCookies()
            }
        })
        this.cookies = Cookies.get()
        this.cacheCookies(this.cookies)
        await this.fetchData()
    },
    methods: {
        ...mapMutations({
            cacheCookies: T.CACHE_COOKIES,
        }),
    },
}
</script>
